module.exports = __webpack_public_path__ + "img/3-1.a7b0c841.svg";